import React from 'react';
import asha from '../images/asha.jpeg';
import tufahel from '../images/tufahel.jpeg';
import soufiane from '../images/soufiane.jpeg';

const Testimonials = () => (
  <div className="Testimonials" id="testimonials">
    <div className="sectionHeading">
      <div className="sectionLeftHeading">
        <h3 className="headingPinked">Testimonials</h3>
        <h2>What people say</h2>
      </div>
      <div className="sectionRightMoreDetails">
        <a href="https://www.linkedin.com/in/nemwel-nyandoro/details/recommendations/?detailScreenTabIndex=0" target="_blank" rel="noreferrer">More testimonials</a>
      </div>
    </div>

    <div className="MyTestimonials">
      <div className="testimonial">
        <div className="testimonialHeader">
          <p className="left">
            <i className="fa fa-comment" aria-hidden="true" />
            <i className="fa fa-comment" aria-hidden="true" />
          </p>
          <p className="right">
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
          </p>
        </div>

        <div className="testimonialBody">
          <p>
            I had the pleasure of working with Nemwel on some projects, where he performed
            code reviews. I must say, his attention to detail and thorough understanding
            of the project requirements made the review process smooth and efficient.
            His constructive feedback and suggestions helped improve the overall quality
            of the code and ensured it met industry standards. He also went the extra
            mile to explain the reasoning behind the comments, making it easy for me to
            understand and implement the necessary changes. Nemwel&apos;s expertise in
            software development is invaluable. I highly recommend Nemwel and look
            forward to working with him again in the future.
            {' '}
          </p>
        </div>

        <div className="testimonialFooter">
          <img src={asha} alt="Asha Vijayan testimonial" />
          <div className="personTitle">
            <h4>Asha Vijayan</h4>
            <p>Software developer</p>
          </div>
        </div>
      </div>

      <div className="testimonial">
        <div className="testimonialHeader">
          <p className="left">
            <i className="fa fa-comment" aria-hidden="true" />
            <i className="fa fa-comment" aria-hidden="true" />
          </p>
          <p className="right">
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
          </p>
        </div>

        <div className="testimonialBody">
          <p>
            Only one word that comes to mind when I think of Nemwel and that&apos;s
            AWESOME. I found the opportunity to work with Nemwel at Microverse and
            he is a very good problem solver using various programming languages.
            He has a nice work ethic with extraordinary skills in the Software
            Development field. Overall, Nemwel was a pleasure to work with and I
            have qualms recommending him to anybody looking for an excellent
            Software Developer.
            {' '}
          </p>
        </div>

        <div className="testimonialFooter">
          <img src={tufahel} alt="Tufahel Ahmed testimonial" />
          <div className="personTitle">
            <h4>Tufahel Ahmed </h4>
            <p>Full-Stack web developer</p>
          </div>
        </div>
      </div>

      <div className="testimonial">
        <div className="testimonialHeader">
          <p className="left">
            <i className="fa fa-comment" aria-hidden="true" />
            <i className="fa fa-comment" aria-hidden="true" />
          </p>
          <p className="right">
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
            <i className="fa fa-star" aria-hidden="true" />
          </p>
        </div>

        <div className="testimonialBody">
          <p>
            I had the opportunity to closely work with Nemwel while studying @
            Microverse. He has exceptional professional skills, consistently
            showing up on time for meetings, and doing his part of the job. He is
            very passionate about code and always striving to improve his craft.
            I firmly believe that wherever Nemwel goes, he will bring a lot of
            positivity of success and growth.
            {' '}
          </p>
        </div>

        <div className="testimonialFooter">
          <img src={soufiane} alt="Soufiane Boursen testimonial" />
          <div className="personTitle">
            <h4>Soufiane Boursen </h4>
            <p>Software Engineer</p>
          </div>
        </div>
      </div>

    </div>
  </div>
);

export default Testimonials;
